import React from 'react';
import { Check, ShieldCheck, Zap } from 'lucide-react';
import GphRichBlock from '../GphRichBlock';

const BENEFITS = [
  'Diagnósticos ilimitados de mira e sensibilidade',
  'Análise de vídeo e spray por IA (retícula)',
  'Calculadoras de mira (PUBG Mobile & Free Fire)',
  'Treinos táticos específicos por jogada',
  'Acesso prioritário a atualizações da Mi'
];

export default function PurchaseProAdapter({ agent, context = {} }) {
  const { host } = agent;
  const isPro = host.entitlements?.isPro === true;

  if (isPro) {
    return (
      <GphRichBlock eyebrow="Plano" title="Você já é Pro" subtitle="Todas as skills operacionais do Game Pro Hub estão destravadas na conversa.">
        <div className="gph-block-actions pt-2">
          <button type="button" className="gph-btn gph-btn--ghost" onClick={() => agent.runCapability('profile_plan', {})}>
            Ver meus limites
          </button>
          <button type="button" className="gph-btn gph-btn--ghost" onClick={() => agent.restart()}>
            Começar outro problema
          </button>
        </div>
      </GphRichBlock>
    );
  }

  const handleSubscribe = (planCode) => {
    if (typeof host.subscribe === 'function') {
      host.subscribe(planCode);
    } else if (typeof host.openPricing === 'function') {
      host.openPricing('plans');
    }
  };

  return (
    <GphRichBlock
      eyebrow="Pro"
      title="ASSINATURA GAME PRO HUB PRO"
      subtitle={context.blockedReason || 'Evolução FPS sem travas: destrave o potencial máximo da IA diretamente nesta conversa.'}
    >
      <div className="space-y-8 pt-4 text-left">
        {/* stacked minimalist plan options */}
        <div className="space-y-6">
          {/* Pro Mensal */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-6 border-b border-white/5">
            <div className="space-y-1">
              <div className="flex items-center gap-2">
                <h4 className="text-base font-bold text-white m-0">Pro Mensal</h4>
                <span className="text-[10px] text-slate-500 font-mono uppercase tracking-wider">Assinatura Flexível</span>
              </div>
              <p className="text-xs text-slate-400 m-0 font-sans">
                Renovação mensal automática. Cancele a qualquer momento.
              </p>
            </div>
            <div className="flex items-center gap-4 shrink-0">
              <div className="text-right">
                <span className="text-xl font-black text-white font-mono">R$ 29,99</span>
                <span className="text-xs text-slate-500 font-mono">/mês</span>
              </div>
              <button
                type="button"
                onClick={() => handleSubscribe('pro_monthly')}
                className="gph-btn gph-btn--ghost text-xs"
              >
                Assinar Mensal
              </button>
            </div>
          </div>

          {/* Pro Anual */}
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-2">
            <div className="space-y-1">
              <div className="flex items-center gap-2.5">
                <h4 className="text-base font-bold text-white m-0">Pro Anual</h4>
                <span className="px-2 py-0.5 bg-lime-500/10 border border-lime-500/30 rounded text-[9px] font-black uppercase text-lime-400 tracking-wider flex items-center gap-1">
                  <Zap size={10} fill="currentColor" /> Melhor Custo
                </span>
              </div>
              <p className="text-xs text-slate-400 m-0 font-sans">
                Acesso Pro por 12 meses. Economize 19% (R$ 24,16/mês).
              </p>
            </div>
            <div className="flex items-center gap-4 shrink-0">
              <div className="text-right">
                <span className="text-xl font-black text-lime-400 font-mono">R$ 289,90</span>
                <span className="text-xs text-slate-500 font-mono">/ano</span>
              </div>
              <button
                type="button"
                onClick={() => handleSubscribe('pro_annual')}
                className="gph-btn gph-btn--primary text-xs"
              >
                Assinar Pro Anual
              </button>
            </div>
          </div>
        </div>

        {/* Benefits Checklist */}
        <div className="space-y-3 pt-2">
          <span className="text-[10px] font-bold uppercase tracking-wider text-slate-500 block">O que você ganha no Pro:</span>
          <ul className="gph-block-list gph-block-list--benefits font-sans">
            {BENEFITS.map((benefit, idx) => (
              <li key={idx} className="flex items-center gap-2.5 text-xs text-slate-200">
                <Check size={14} className="text-lime-400 shrink-0" />
                <span>{benefit}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Stripe Footer */}
        <div className="border-t border-white/5 pt-5 flex flex-col sm:flex-row sm:items-center justify-between gap-3 text-xs text-slate-400 font-sans">
          <span className="flex items-center gap-1.5 font-medium">
            <ShieldCheck size={14} className="text-lime-400" /> Checkout oficial criptografado Stripe
          </span>
          <button type="button" className="text-slate-400 hover:text-white underline text-[11px]" onClick={() => agent.restart()}>
            Continuar no plano gratuito
          </button>
        </div>
      </div>
    </GphRichBlock>
  );
}
